// Func = limiting Scope for this file
var lastScrollTop = 0;
var opened = 0;
var start = $("#arriveInput").attr("value");
var end = $("#departureInput").attr("value");
(function () {
  $(document).ready(function () {
    //Call function with browser is resized.
    $(window).resize(function (event) {
      //resizeWindow();
    });
    //resizeWindow();
    weather();
    // Main Nav Dropdown
    $("#primary-nav li").hover(
      function () {
        $(this).addClass("hover");
        $("ul.submenu", this).fadeIn(200);
      },
      function () {
        $(this).removeClass("hover");
        $("ul.submenu", this).fadeOut(200);
      }
    );

    //To create after event
    $.datepicker._updateDatepicker_original = $.datepicker._updateDatepicker;
    $.datepicker._updateDatepicker = function (inst) {
      $.datepicker._updateDatepicker_original(inst);
      var afterShow = this._get(inst, "afterShow");
      if (afterShow) afterShow.apply(inst.input ? inst.input[0] : null); // trigger custom callback
    };

    $("#bookingCalendar").datepicker({
      changeMonth: false,
      dateFormat: "yy-mm-dd",
      numberOfMonths: 2,
      minDate: 0,
      beforeShowDay: function (date) {

        setTimeout(function() {
          document.querySelectorAll('.ui-datepicker-calendar td a').forEach(e => {
            e.setAttribute('tabindex', '-1');
          })
        }, 1000);
        $.datepicker._defaults.dateFormat = "yy-mm-dd";
        var startDate = $.datepicker.parseDate(
          $.datepicker._defaults.dateFormat,
          start
        );
        var endDate = $.datepicker.parseDate(
          $.datepicker._defaults.dateFormat,
          end
        );
        if (date.getTime() == startDate.getTime()) {
          return [true, "startday"];
        } else {
          if (date.getTime() == endDate.getTime()) {
            return [true, "endday"];
          } else {
            if (
              date.getTime() > startDate.getTime() &&
              date.getTime() < endDate.getTime()
            ) {
              return [true, "days"];
            } else {
              return [true, ""];
            }
          }
        }
      },
      onSelect: function (date) {
        var arrive = $.datepicker.parseDate(
          $.datepicker._defaults.dateFormat,
          start
        );
        var departure = $.datepicker.parseDate(
          $.datepicker._defaults.dateFormat,
          end
        );
        var selectedDate = $.datepicker.parseDate(
          $.datepicker._defaults.dateFormat,
          date
        );

        if (opened == 0) {
          opened = 1;
          start = date;
          end = date;
        } else {
          opened = 0;
          if (selectedDate <= arrive) {
            end = start;
            start = date;
          } else {
            end = date;
          }
        }
        $("#arriveInput").attr("value", start);
        $("#departureInput").attr("value", end);

        $("#altDates").attr("value", start + " | " + end);
      },
      onChangeMonthYear: function () {},
    });

    // Map: Return to previous page button. Change body id to match map template's name.
    //$('body#map-category-sidebar #content').prepend('<a class="btn return-from-map" href="javascript:history.back()">« Back to previous page</a>');
  });

  window.onload = function () {
    const navItems = document.querySelectorAll('#privary-navigation li');
    let middleNavElement = Math.floor(navItems.length / 2);
    // if (navItems[middleNavElement]){
    //   navItems[middleNavElement].classList.add('separator');
    // }

    /*this function add a class to header when scroll down the page
		/* and change the logo by a new file if needed depending of mockup
		*/

    // scrollDownAction(20, 'scroll');

    scrollW();
    window.addEventListener("scroll", function () {
      scrollW();
    });
  };
  //Login
  let loginblock = document.querySelector(".login-form");
  let loginBtn = document.querySelectorAll(".js-btn-login");
  if (loginBtn) {
    loginBtn.forEach((item) => {
      item.addEventListener("click", (e) => {
        e.preventDefault();
        loginblock.classList.toggle("is-open");
      });
    });
  }
  //Booking
  let bookBtn = document.querySelectorAll(".btn-book");
  bookBtn.forEach((item) => {
    item.addEventListener("click", (e) => {
      e.preventDefault();
      document.querySelector(".content-booking").classList.toggle("is-open");
    });
  });
  let jsMenu = document.querySelectorAll(".js-menu");
  if (jsMenu) {
    jsMenu.forEach((item) => {
      item.addEventListener("click", (e) => {
        e.preventDefault();
        document.querySelector(".mobile-menu").classList.toggle("open");
      });
    });
  }
})();

function weather() {
  let state = "North Carolina";
  let weather_grades = document.getElementById("temp-js");
  let weather_speed = document.getElementById("speed-js");
  fetch(
    `https://api.openweathermap.org/data/2.5/weather?q=${state},us&APPID=0ddd1af8b5b1833cedd6da7a90934cce&units=imperial`
  )
    .then(function (response) {
      return response.json();
    })
    .then(function (myJson) {
      //console.log(myJson)
      if (weather_grades != null) {
        weather_grades.innerHTML = parseInt(myJson.main.temp) + "°F";
        weather_speed.innerHTML = parseInt(myJson.wind.speed) + "/MPH";
      }
    });
}

function scrollW() {
  //check scroll down or up for header styles
  let st = window.pageYOffset || document.documentElement.scrollTop;

  let logo_container = document.querySelector(".header__logo--up");
  let alter_logo =
    "<img src='/assets/images/bear.png' alt='waynesville bear logo'/>";

  if (st > 80) {
    if (st > lastScrollTop) {
      // downscroll code
      if (!document.getElementById("header").classList.contains("down")) {
        document.getElementById("header").classList.add("down");

        if (
          document.querySelector(".header__logo--up svg") &&
          window.innerWidth >= 800
        ) {
          logo_container.removeChild(
            document.querySelector(".header__logo--up svg")
          );
        } 
        // else {
        //   logo_container.removeChild(
        //     document.querySelector(".header__logo--up img")
        //   );
        // }
        window.innerWidth >= 800
          ? logo_container.innerHTML = alter_logo
          : null;

        document.getElementById("header").classList.remove("up");
      }
    } else {
      // upscroll code
      if (!document.getElementById("header").classList.contains("up")) {
        document.getElementById("header").classList.add("up");
        document.getElementById("header").classList.remove("down");
      }
    }
  } else {
    if (
      document.getElementById("header").classList.contains("up") ||
      document.getElementById("header").classList.contains("down")
    ) {
      document.getElementById("header").classList.remove("up");
      document.getElementById("header").classList.remove("down");

      if (
        document.querySelector(".header__logo--up img") &&
        window.innerWidth >= 800 &&
        document.querySelector("#home")
      ) {
        document.querySelector(".header__logo--up img").src =
          "/assets/svg/WaynesvilleInnAndGolfClub.svg";
        document.querySelector(".header__logo--up img").classList.add("logo");
      } else if (
        document.querySelector(".header__logo--up img") &&
        window.innerWidth >= 800
      ) {
        document.querySelector(".header__logo--up img").src =
        "/assets/svg/WaynesvilleInnAndGolfClubblue.png";
        document.querySelector(".header__logo--up img").classList.add("logo");
      }
    }
    if (
      document.getElementById("attractions") &&
      !document.getElementById("header").classList.contains("up")
    ) {
      document.getElementById("header").classList.add("up");
    }
  }
  lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}

// change instagram icon in footer
$(".social-media li:last-child a svg").remove();
$(".social-media li:last-child a").append(
  "<img src='assets/svg/icon-instagram.svg' alt='instagram icon' class='instagram-icon'>"
);

// change placeholder date-filed
$("input[type=date]").on("input", function () {
  if ($(this).val().length > 0) {
    $(this).addClass("full");
  } else {
    $(this).removeClass("full");
  }
});

//History Arrows
if (document.querySelector(".history-block")) {
  let rows = document.querySelectorAll(".history-block .row");
  let btn_prev = document.querySelector("button.btn-prev");
  let btn_next = document.querySelector("button.btn-next");
  let counter = 1;
  let margin = 0;
  let container = document.querySelector(".history-block .container");

  btn_next.addEventListener("click", () => {
    if (counter < rows.length) {
      let nextSlide = document.getElementById(`row-${counter + 1}`);
      let top = nextSlide.offsetTop;
      container.scrollTop = top;
      counter++;
      console.log({ top, counter });
    }
  });
  btn_prev.addEventListener("click", () => {
    if (counter > 0) {
      let prevSlide = document.getElementById(`row-${counter - 1}`);
      let top = prevSlide.offsetTop;
      container.scrollTop = top;
      counter--;
      console.log({ top, counter });
    }
  });
}

function clickOn(margin) {
  let container = document.querySelector(".history-block .container");
}
